// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_1BG","cls2":"ImpactNavBar-cls2_YOw ImpactNavBar-cls1_1BG"};